import { request } from "@/utils";
import api from "./index";

// 組織相關api
const organizationApi = {
  /** 創建組織 */
  createOrganization: async (organization) => {
    console.log(organization);
    try {
      const res = await api.post(`/private/organization/`, organization);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 取得自己的組織資訊 */
  getMyOrganizations: async () => {
    try {
      const res = await api.get(`/private/organization/`);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  /** 取得所有組織 */
  getOrganizations: async () => {
    try {
      const res = await request.get(`/public/organization/`);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 取得組織身份組 */
  getIdentityGroups: async (organizationId) => {
    try {
      const res = await request.get(`/public/identity/all/${organizationId}`);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 申請加入組織 */
  applyJoinOrganization: async (identityId) => {
    try {
      const res = await api.post(`/private/identity/apply/${identityId}`, {
        identity_id: identityId,
      });
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  // --------------------
  /** 取得旗下所有業者，及其本月預約數
   * @param {string} organizationId - 組織id
   */
  getServiceProviders: async (organizationId) => {
    const res = await request.get(
      `/api/organization/${organizationId}/appointments`,
    );
    return res;
  },
  /** 取得旗下業者所有已綁定顧客
   * @param {string} organizationId - 組織id
   */
  getCustomers: async (organizationId) => {
    const res = await request.get(`/api/organization/${organizationId}/users`);
    return res;
  },
  /** 取得時間區間內預約單
   * @param {string} organizationId - 組織
   * @param {string} startDate - 開始日期
   * @param {string} endDate - 結束日期
   */
  getAppointments: async (organizationId, startDate, endDate) => {
    const res = await request.get(
      `/api/organization/${organizationId}/upcoming_appointments`,
      {
        params: {
          start_time: startDate,
          end_time: endDate,
        },
      },
    );
    return res;
  },
  /** 取得組織資訊
   * @param {string} orgId - 組織 ID
   */
  getOrganization: async (orgId) => {
    try {
      const res = await api.get(`/public/organization/byID/${orgId}`);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 取得組織分類
   * @returns {Promise<Array>} 組織分類列表
   */
  getOrganizationCategories: async () => {
    try {
      const res = await api.get("/public/organization_categories/");
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  /** 刪除組織圖片
   * @param {string} orgId - 組織 ID
   * @param {string} pictureId - 圖片 ID
   */
  deleteOrganizationPicture: async (orgId, pictureId) => {
    try {
      const res = await api.delete(`/private/organization/pictures/${orgId}`, {
        params: {
          picture_id: pictureId,
        },
      });
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 更新組織圖片
   * @param {string} orgId - 組織 ID
   * @param {FormData} formData - 包含圖片的表單數據
   */
  updateOrganizationAvatar: async (orgId, formData) => {
    try {
      const res = await api.post(
        `/private/organization/pictures/${orgId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 更新組織名稱
   * @param {string} orgId - 組織 ID
   * @param {string} name - 組織名稱
   */
  updateOrganizationName: async (orgId, name) => {
    try {
      const res = await api.patch(`/private/organization/name/${orgId}`, null, {
        params: {
          name: name,
        },
      });
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 更新組織描述
   * @param {string} orgId - 組織 ID
   * @param {string} description - 組織描述
   */
  updateOrganizationDescription: async (orgId, description) => {
    try {
      const res = await api.patch(
        `/private/organization/description/${orgId}`,
        null,
        {
          params: {
            description: description,
          },
        },
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 更新組織地址
   * @param {string} orgId - 組織 ID
   * @param {string} address - 組織地址
   */
  updateOrganizationAddress: async (orgId, address, regionId) => {
    try {
      const res = await api.patch(
        `/private/organization/address/${orgId}`,
        null,
        {
          params: {
            address: address,
            region_id: regionId,
          },
        },
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 更新組織電話
   * @param {string} orgId - 組織 ID
   * @param {string} phone - 組織電話
   */
  updateOrganizationPhone: async (orgId, phone) => {
    try {
      const res = await api.patch(
        `/private/organization/phone/${orgId}`,
        null,
        {
          params: {
            phone: phone,
          },
        },
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 更新組織電子郵件
   * @param {string} orgId - 組織 ID
   * @param {string} email - 組織電子郵件
   */
  updateOrganizationEmail: async (orgId, email) => {
    try {
      const res = await api.patch(
        `/private/organization/email/${orgId}`,
        null,
        {
          params: {
            email: email,
          },
        },
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 新增服務區域
   * @param {string} orgId - 組織 ID
   * @param {string} regionId - 區域 ID
   */
  addOrganizationRegion: async (orgId, regionIds) => {
    try {
      const queryParams = new URLSearchParams({});
      if (Array.isArray(regionIds) && regionIds.length > 0) {
        regionIds.forEach((id) => {
          queryParams.append("service_region_ids", id);
        });
      }
      const res = await api.post(
        `/private/organization/sr/${orgId}?${queryParams.toString()}`,
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 刪除服務區域
   * @param {string} orgId - 組織 ID
   * @param {string} regionId - 區域 ID
   */
  deleteOrganizationRegion: async (orgId, regionIds) => {
    try {
      const queryParams = new URLSearchParams({});
      if (Array.isArray(regionIds) && regionIds.length > 0) {
        regionIds.forEach((id) => {
          queryParams.append("service_region_ids", id);
        });
      }
      const res = await api.delete(
        `/private/organization/sr/${orgId}?${queryParams.toString()}`,
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 更新組織其他資訊
   * @param {string} orgId - 組織 ID
   * @param {Object} data - 組織其他資訊
   */
  updateOrganizationMiscJson: async (orgId, data) => {
    try {
      const res = await api.patch(`/private/organization/misc_json/${orgId}`, {
        data: data,
      });
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 新增組資product_category
   * @param {string} orgId - 組織 ID
   * @param {string} productCategoryIds - 產品分類 ID
   */
  addOrganizationProductCategory: async (orgId, productCategoryIds) => {
    try {
      const queryParams = new URLSearchParams({});
      if (Array.isArray(productCategoryIds) && productCategoryIds.length > 0) {
        productCategoryIds.forEach((id) => {
          queryParams.append("product_category_ids", id);
        });
      }
      const res = await api.post(
        `/private/organization/org_product_categories/${orgId}?${queryParams.toString()}`,
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 刪除組資product_category
   * @param {string} orgId - 組織 ID
   * @param {string} productCategoryIds - 產品分類 ID
   */
  deleteOrganizationProductCategory: async (orgId, productCategoryIds) => {
    try {
      const queryParams = new URLSearchParams({});
      if (Array.isArray(productCategoryIds) && productCategoryIds.length > 0) {
        productCategoryIds.forEach((id) => {
          queryParams.append("product_category_ids", id);
        });
      }
      const res = await api.delete(
        `/private/organization/org_product_categories/${orgId}?${queryParams.toString()}`,
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 新增組織 org category
   * @param {string} orgId - 組織 ID
   * @param {string} categoryIds - 分類 ID
   */
  addOrganizationCategory: async (orgId, categoryIds) => {
    try {
      const queryParams = new URLSearchParams({});
      if (Array.isArray(categoryIds) && categoryIds.length > 0) {
        categoryIds.forEach((id) => {
          queryParams.append("category_ids", id);
        });
      }
      const res = await api.post(
        `/private/organization/org_categories/${orgId}?${queryParams.toString()}`,
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 刪除組織 org category
   * @param {string} orgId - 組織 ID
   * @param {string} categoryIds - 分類 ID
   */
  deleteOrganizationCategory: async (orgId, categoryIds) => {
    try {
      const queryParams = new URLSearchParams({});
      if (Array.isArray(categoryIds) && categoryIds.length > 0) {
        categoryIds.forEach((id) => {
          queryParams.append("category_ids", id);
        });
      }
      const res = await api.delete(
        `/private/organization/org_categories/${orgId}?${queryParams.toString()}`,
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  /** 更新組織序號
   * @param {string} orgId - 組織 ID
   * @param {string} serialNumber - 序號
   */
  updateOrganizationSerialNumber: async (orgId, serialNumber) => {
    try {
      const res = await api.patch(
        `/private/organization/serial_number/${orgId}`,
        null,
        {
          params: {
            serial_number: serialNumber,
          },
        },
      );
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export default organizationApi;
